import { Icon, P1 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './Promotion.module.scss'

const Promotion = ({ promotion, website }) => (
  <div className={styles.Promotion}>
    <div className={styles.MainGift}>
      <Icon icon="icon-gift" />
      <P1>{promotion}</P1>
    </div>

    <a href={website} target="_blank" rel="noreferrer">
      <span>Visit Website</span>
      <Icon icon="icon-arrow-right" size={18} />
    </a>
  </div>
)

Promotion.propTypes = {
  promotion: PropTypes.string,
  website: PropTypes.string
}

Promotion.defaultProps = {
  promotion: '',
  website: ''
}

export default Promotion
